import { render, staticRenderFns } from "./TemplateStepsWithIconsFlexible.vue?vue&type=template&id=6c39e152&scoped=true&"
import script from "./TemplateStepsWithIconsFlexible.vue?vue&type=script&lang=js&"
export * from "./TemplateStepsWithIconsFlexible.vue?vue&type=script&lang=js&"
import style0 from "./TemplateStepsWithIconsFlexible.vue?vue&type=style&index=0&id=6c39e152&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c39e152",
  null
  
)

export default component.exports